import { useState, useEffect } from 'react';
import { Multiplexer, } from '@streem/sdk-core';
import { useObservable } from './rxjs';
import { CameraSubject } from 'streem-sdk-protobuf';
export function useMultiplexer(roomSession, videoController, container) {
    // TODO https://streempro.atlassian.net/browse/STREEM-8225
    // Camera switching will involve handling using different compositors
    // We should create something similar to Go's Context package to
    // signal the compositor to pause while we create a new compositor.
    const [cameraSubject] = useObservable(videoController.cameraSubject);
    const [connected] = useObservable(videoController.connected);
    const [canvasDims, setCanvasDims] = useState(undefined);
    useEffect(() => {
        let multiplexer = undefined;
        if (container?.current && connected) {
            multiplexer = new Multiplexer({
                roomSession,
                container: container.current,
                videoStarter: videoController,
                cameraSubject: cameraSubject ?? CameraSubject.CAMERA_SUBJECT_PERSON,
                isLocalVideo: videoController.ownerIsLocalUser,
            });
            multiplexer.start();
        }
        const canvasDimensionsSubscription = multiplexer?.canvasDimensions.subscribe({
            next: dims => {
                setCanvasDims(dims);
            },
            error: err => console.error('Error with canvas dimensions: ', err),
        });
        return () => {
            if (multiplexer) {
                multiplexer.stop();
            }
            if (canvasDimensionsSubscription) {
                canvasDimensionsSubscription.unsubscribe();
            }
        };
    }, [roomSession, container, videoController, cameraSubject, connected]);
    return canvasDims;
}
//# sourceMappingURL=use_multiplexer.js.map